import { RelativeTimeElement } from '@github/relative-time-element';
import { createComponent } from '../utils/custom-element.js';

const RelativeTime = createComponent(RelativeTimeElement, 'relative-time');

export { RelativeTime as default };
